import React from 'react';
import { PieChart, Zap, Disc } from 'lucide-react';
import { useApp } from '../../context/AppContext';

export const MaterialTotals: React.FC = () => {
  const { materialTotals, lineItems, setActiveView } = useApp();
  const { wireHashMap, conduitHashMap } = materialTotals;

  if (lineItems.length === 0) {
    return null;
  }

  const wireKeys = Object.keys(wireHashMap);
  const conduitKeys = Object.keys(conduitHashMap);

  return (
    <div style={{ marginBottom: '24px' }}>
      <h2 className="section-title">
        <PieChart className="h-5 w-5 text-amber-500" />
        <span>Material Totals</span>
      </h2>

      <div className="material-totals-grid">
        {/* Wire Totals Card */}
        <div className="totals-category-card">
          <h3>
            <Zap className="h-4 w-4 text-amber-500" />
            <span>Wire Totals</span>
          </h3>

          <div className="totals-list">
            {wireKeys.length > 0 ? (
              wireKeys.map((size) => (
                <div key={size} className="metric-item">
                  <div className="metric-info">
                    <span className="metric-label">{size}</span>
                  </div>
                  <div className="metric-value">
                    {Math.round(wireHashMap[size]).toLocaleString()}{' '}
                    <span className="metric-unit">ft</span>
                  </div>
                </div>
              ))
            ) : (
              <div className="metric-empty">No wire runs calculated.</div>
            )}
          </div>
        </div>

        {/* Conduit Totals Card */}
        <div className="totals-category-card">
          <h3>
            <Disc className="h-4 w-4 text-amber-500" />
            <span>Conduit Totals</span>
          </h3>

          <div className="totals-list">
            {conduitKeys.length > 0 ? (
              conduitKeys.map((type) => (
                <div key={type} className="metric-item">
                  <div className="metric-info">
                    <span className="metric-label">{type}</span>
                  </div>
                  <div className="metric-value">
                    {Math.round(conduitHashMap[type]).toLocaleString()}{' '}
                    <span className="metric-unit">ft</span>
                  </div>
                </div>
              ))
            ) : (
              <div className="metric-empty">No conduit runs calculated.</div>
            )}
          </div>
        </div>
      </div>

      {/* Quick Launch to Material BOM */}
      <div style={{ marginTop: '12px' }}>
        <button
          type="button"
          className="btn-primary"
          style={{ width: '100%', padding: '11px 16px', fontSize: '0.9rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
          onClick={() => setActiveView('MATERIAL_LIST')}
        >
          <span>Open Full Material List &amp; NEC Calculator &rarr;</span>
        </button>
      </div>
    </div>
  );
};
